import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const createOverlayManager = (Renderer) => {
  const OverlayContext = createContext(null);

  const Provider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [overlay, setOverlay] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const open = (Component, props = {}, options = {}) => {
      setOverlay({
        Component,
        props,
        options,
      });

      setIsOpen(true);

      navigate(location.pathname, {
        state: { drawerOpen: true },
      });
    };

    const close = () => {
      setIsOpen(false);

      navigate(location.pathname, {
        state: { drawerOpen: false },
      });
    };

    // Sync with browser navigation (back / forward)
    useEffect(() => {
      if (!location.state?.drawerOpen && isOpen) {
        setIsOpen(false);
      }
    }, [location.state, isOpen]);

    return (
      <OverlayContext.Provider value={{ open, close }}>
        {children}

        {overlay && (
          <Renderer
            Component={overlay.Component}
            props={overlay.props}
            options={overlay.options}
            isOpen={isOpen}
            onClose={close}
          />
        )}
      </OverlayContext.Provider>
    );
  };

  const useOverlay = () => {
    const ctx = useContext(OverlayContext);
    if (!ctx) {
      throw new Error('Overlay hook must be used inside Provider');
    }
    return ctx;
  };

  return { Provider, useOverlay };
};
